import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registering the service worker is what makes the browser offer to install the
// app; without one, Chrome shows no install prompt at all. Registered after load
// so it never competes with the first render.
//
// Only in a production build: the development server serves an older copy of a
// file often enough that a caching layer on top of it wastes an afternoon.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch((error) => {
        // An app that works without being installable is fine. One that fails
        // to start because a service worker would not register is not.
        console.log('Service worker registration failed:', error);
      });
  });
}
